/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Map_FromInputs */

const cs_pipelines_map_from = /** @type {(inputs: Pipelines_Map_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z`)
};

const en_pipelines_map_from = /** @type {(inputs: Pipelines_Map_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Pipelines_Map_FromInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_map_from = /** @type {((inputs?: Pipelines_Map_FromInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Map_FromInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_map_from(inputs)
	return cs_pipelines_map_from(inputs)
});